<script>
export default {
	data() {
		return {
			steps:  [
				{
					target: '[data-v-step="0"]',  // We're using document.querySelector() under the hood
					header: {
						title: 'Haz clic en la pestaña Clientes',
					},
					params: {
						enableScrolling: false
					},
					content: `Para iniciar un ARCE debes primero seleccionar el cliente`
				}
			],

			stepsClients:  [
				{
					target: '[data-v-step="1"]',
					header: {
						title: 'Pestaña de Clientes',
					},
					params: {
						enableScrolling: false
					},
					content: 'Esta es la pestaña de clientes, para selecionar un cliente tienes 2 opciones'
				},
				{
					target: '[data-v-step="2"]',
					header: {
						title: 'Opción uno',
					},
					params: {
						enableScrolling: false
					},
					content: 'Haz clic en el botón nuevo para iniciar un ARCE',
				},
				{
					target: '[data-v-step="3"]',
					header: {
						title: 'Opción dos',
					},
					params: {
						enableScrolling: false
					},
					content: 'Pudes buscar cliente por nombre, número de cliente o número de grupo',
					
				},
				{
					target: '[data-v-step="4"]',
					header: {
						title: 'Seleccionar Cliente',
					},
					params: {
						enableScrolling: false
					},
					content: 'Selecciona un cliente para ingresar a su ficha',
					
				}
			],

			stepsClient: [
				{
					target: '[data-v-step="c1"]',
					
					params: {
						enableScrolling: false
					},
					content: `Haz clic en el boton ARCE para iniciar.`
				}
			],

			stepsWizardArce: [
				{
					target: '[data-v-step="w0-1"]',  // We're using document.querySelector() under the hood
					content: `Inicia un Análisis o Rating como proceso independiente.`,
					
				},
				{
					target: '[data-v-step="w1"]',  // We're using document.querySelector() under the hood
					content: `Verifica que la estructura del grupo comercial este completa.`,
					
				},
				{
					target: '[data-v-step="w2"]',  // We're using document.querySelector() under the hood
					content: `Selecciona nuevo análisis.`,
					params: {
						placement: 'left'
					}
				},
				{
					target: '[data-v-step="w3a"]',  // We're using document.querySelector() under the hood
					content: `NOTA: Recuerda que toda la información debe ser previamente cargada en Fortimax para que puedas continuar de manera óptima con ARCE.`,
					params: {
						placement: 'bottom'
					}
				},
				{
					target: '[data-v-step="w3"]',  // We're using document.querySelector() under the hood
					content: `Verifica que cuentas con toda la información actualizada. Si cuentas con parte de la información marca las casillas correpondientes y haz clic en posponer.`,
					params: {
						placement: 'left'
					}
				},
				{
					target: '[data-v-step="w4"]',  // We're using document.querySelector() under the hood
					content: `Seleciona el sector del cliente. Si tu cliente no es del sector Construcción selecciona Genérico`,
					params: {
						placement: 'left'
					}
				},
				{
					target: '[data-v-step="w4-2"]',  // We're using document.querySelector() under the hood
					content: `Seleciona la opción NO, si eres de México`,
					params: {
						placement: 'left'
					}
				},
				{
					target: '[data-v-step="w5"]',  // We're using document.querySelector() under the hood
					content: `Haz clic en Terminar para iniciar preparción de ARCE`,
					params: {
						placement: 'left'
					}
				}
			],
			stepsWizardArcePosponed: [
				{
					target: '[data-v-step="w3"]',  // We're using document.querySelector() under the hood
					content: `Marca todas las casillas si cuentas con la información completa y haz clic en Siguiente.`,
					params: {
						placement: 'left'
					}
				},
				{
					target: '[data-v-step="w4"]',  // We're using document.querySelector() under the hood
					content: `Seleciona el sector del cliente. Si tu cliente no es del sector Construcción selecciona Genérico`,
					params: {
						placement: 'left'
					}
				},
				{
					target: '[data-v-step="w4-2"]',  // We're using document.querySelector() under the hood
					content: `Seleciona NO, esta opcion no es utilizada en Mexico`,
					params: {
						placement: 'left'
					}
				},
				{
					target: '[data-v-step="w5"]',  // We're using document.querySelector() under the hood
					content: `Haz clic en Terminar para iniciar preparción de ARCE`,
					params: {
						placement: 'left'
					}
				}
			],
			stepsClientSearch: [
				{
					target: '[data-v-step="cs1"]',  // We're using document.querySelector() under the hood
					content: `Busca un cliente por nombre, número de cliente o número de grupo.`,
					params: {
						placement: 'left'
					}
				},
				{
					target: '[data-v-step="cs2"]',  // We're using document.querySelector() under the hood
					content: `Haz clic en contrinuar para iniciar ARCE.`,
					
				},
			],

			stepsArceDetails: [
				{
					target: '[data-v-step="ad1"]',  // We're using document.querySelector() under the hood
					content: `Este es el folio que debes utilizar para crear tu expediente en Fortimax`,
					header: {
						title: 'Folio Fortimax',
					},
					params: {
						placement: 'right',
						enableScrolling: false
					}
				},
				{
					target: '[data-v-step="ad2"]',  // We're using document.querySelector() under the hood
					content: `Aquí se marca el estado del ARCE`,
					header: {
						title: 'Estado análisis ARCE',
					},
					params: {
						placement: 'bottom',
						enableScrolling: false
					}
				},
				{
					target: '[data-v-step="ad3"]',  // We're using document.querySelector() under the hood
					content: `Haz clic en el botón  <img src="simulator/arce/ad5_1.png" width="20px" /> para agregar las filiales`,
					header: {
						title: 'Agregar Filiales',
					},
					params: {
						placement: 'left',
						enableScrolling: false
					}
				},
				{
					target: '[data-v-step="ad4"]',  // We're using document.querySelector() under the hood
					content: `En esta sección se listan las filales pertenecientes al Grupo`,
					header: {
						title: 'Estructura del Grupo',
					},
					params: {
						placement: 'top',
					}
				},
				{
					target: '[data-v-step="ad5"]',  // We're using document.querySelector() under the hood
					content: `<div class="text-left">Haz clic en el botón <img src="simulator/arce/ad5_1.png" width="20px" /> para agregar la filial. <br><br> Haz clic en el botón <img src="simulator/arce/ad5_2.png" width="20px" />  para excluir la filial</div>`,
					header: {
						title: 'Agregar o excluir filiales',
					},
					params: {
						placement: 'left',
					}
				},
				{
					target: '[data-v-step="ad6"]',  // We're using document.querySelector() under the hood
					content: `Haz clic en Close cuando termines de seleccionar las filiales para el análisis.`,
					header: {
						title: 'Continuar con el análisis',
					},
					params: {
						placement: 'left',
					}
				},
				{
					target: '[data-v-step="ad7"]',  // We're using document.querySelector() under the hood
					content: `<div class="text-left">En esta sección puedes ver el cromo Grupo y los cromos de las filiales seleccionadas.</div>`,
					header: {
						title: 'Cromos estructura de Grupo',
					},
					params: {
						placement: 'top',
					}
				},
				{
					target: '[data-v-step="ad8"]',  // We're using document.querySelector() under the hood
					content: `<div class="text-left">Haz clic en el cromo de una filial para iniciar el llenado de las fichas. El Cromo Grupo debes llenarlo al completar y verificar todas las filiales.</div>
							<br>
							<div class="text-left"><b>NOTA:</b> Al seleccionar un cromo este se marca de un color distinto al resto de cromos. <br> Debes iniciar con los cromos de las filiales antes de llenar las fichas del cromo Grupo.</div>`,
					header: {
						title: 'Selecciona cromo filial',
					},
					params: {
						placement: 'right',
						enableScrolling: false
					}
				},
				{
					target: '[data-v-step="ad9"]',  // We're using document.querySelector() under the hood
					content: `<div class="text-left">En esta sección están las fichas que debes llenar con la información del cliente.</div>`,
					header: {
						title: 'Fichas ARCE',
					},
					params: {
						placement: 'top',
						enableScrolling: true
					},
					offset: -200
				},
				{
					target: '[data-v-step="ad10"]',  // We're using document.querySelector() under the hood
					content: `<div class="text-left">Algunas fichas marcan un porcentaje de completitud, para un llenado correcto de la ficha la completitud debe marcar 100%.</div>
						<br>
							<div class="text-left"><b>NOTA:</b> En la mayoría de los casos la secuencia del llenado de las fichas no es estricto, pero recomendamos complementar las fichas en el orden que se muestran.</div:`,
					header: {
						title: 'Completitud ficha',
					},
					params: {
						placement: 'right',
						enableScrolling: true
					},
					offset: -200
				},
				{
					target: '[data-v-step="ad11"]',  // We're using document.querySelector() under the hood
					content: `<div class="text-left">Haz clic en el botón editar dentro de la ficha para complementar la información.</div>`,
					header: {
						title: 'Editar ficha',
					},
					params: {
						placement: 'right',
						enableScrolling: true
					},
					offset: -200
				},
				{
					target: '[data-v-step="ad10"]',  // We're using document.querySelector() under the hood
					content: `<div class="text-left">Valida constantemente tu porcentaje de avance, debes llegar al 100%.</div>`,
					header: {
						title: 'Validación de avance',
					},
					params: {
						placement: 'right',
						enableScrolling: true
					},
					offset: -200
				},
				{
					target: '[data-v-step="ad12"]',  // We're using document.querySelector() under the hood
					content: `<div class="text-left">Captura la información en todas las fichas de cada Cromo.</div>`,
					header: {
						title: 'Complementa todas las fichas',
					},
					params: {
						placement: 'right',
						enableScrolling: true
					},
					offset: -200
				},
			],
			
			stepsAnalysisBasicEdit: [
				{
					target: '[data-v-step="abe1"]',  // We're using document.querySelector() under the hood
					content: `Este es el panel edición`,
					header: {
						title: 'Editar ficha',
					},
					params: {
						placement: 'top',
						enableScrolling: false
					}
				},
				{
					target: '[data-v-step="abe2"]',  // We're using document.querySelector() under the hood
					content: `Haz clic en los encabecezados de las secciones para mostrar su contenido`,
					header: {
						title: 'Mostrar campos',
					},
					params: {
						placement: 'bottom',
						enableScrolling: false
					}
				},
				{
					target: '[data-v-step="abe3"]',  // We're using document.querySelector() under the hood
					content: `Este es un campo editable, si posees la información puedes llenarlo.`,
					header: {
						title: 'Campos editables',
					},
					params: {
						placement: 'right',
					}
				},
				{
					target: '[data-v-step="abe4"]',  // We're using document.querySelector() under the hood
					content: `Todos los campos que sean requeridos mostrarán un *; estos campos afectarán el porcentaje de avance de la ficha.`,
					header: {
						title: 'Campos editables requeridos',
					},
					params: {
						placement: 'bottom',
					}
				},
				{
					target: '[data-v-step="abe45"]',  // We're using document.querySelector() under the hood
					content: `Estos campos contienen información previamente cargada en otra etapa de preparación del cliente. No debes llenar estos campos`,
					header: {
						title: 'Campos no editables',
					},
					params: {
						placement: 'right',
					}
				},
				{
					target: '[data-v-step="abe6"]',  // We're using document.querySelector() under the hood
					content: `En caso de eliminar la edición, haz clic en el botón cancelar<br>
					`,
					header: {
						title: 'Cancelar llenado',
					},
					params: {
						placement: 'right',
					}
				},
				{
					target: '[data-v-step="abe7"]',  // We're using document.querySelector() under the hood
					content: `Guarda el avance de la información capturada continuamente, no es necesario tener el 100% de la ficha para almacenar. <br>
							<br>
							<div><b>NOTA:</b> siempre guarda antes de salir, si no perderás lo registrado.</div>
					`,
					header: {
						title: 'Guardar avance',
					},
					params: {
						placement: 'right',
					}
				},
			],

			stepsAnalysisFinancialRisk: [
				{
					target: '[data-v-step="afr1"]',  // We're using document.querySelector() under the hood
					content: `Selecciona los EEFF previamente cargados en RI, posteriormente edita la ficha Riesgo Financiero. <br><br> 
					Haz clic en el encabezado de Resumen Balance General / Resumen Estado de Resultados.`,
					header: {
						title: 'Buscar EEFF',
					},
					params: {
						placement: 'bottom',
						enableScrolling: true
					},
					offset: -200

				},
				{
					target: '[data-v-step="afr2"]',  // We're using document.querySelector() under the hood
					content: `Haz clic en 'Buscar EEFF' para mostrar los EEFF cargados en RI.`,
					header: {
						title: 'Buscar EEFF',
					},
					params: {
						placement: 'bottom',
						enableScrolling: true
					},
					offset: -200

				},
				{
					target: '[data-v-step="afr3"]',  // We're using document.querySelector() under the hood
					content: `Selecciona los EEFF validos para poder continuar.`,
					header: {
						title: 'Selecionar EEFF',
					},
					params: {
						placement: 'top',
						enableScrolling: false
					},

				},
				{
					target: '[data-v-step="afr4"]',  // We're using document.querySelector() under the hood
					content: `<div class="text-left">Haz clic en Agregar Estados para continuar.
					<br>
					<br>
					<div><b>NOTA:</b> es importante que tengas en cuenta que este proceso no se reflejara en la completitud de la ficha Riesgo Financiero pero si afectara al momento de calcular el Rating en ficha Rating.</div></div>

					</div>`,
					header: {
						title: 'Agregar EEFF',
					},
					params: {
						placement: 'right',
						enableScrolling: false
					},

				},
				{
					target: '[data-v-step="afr5"]',  // We're using document.querySelector() under the hood
					content: `Haz clic en 'Editar' para complementar la ficha.`,
					header: {
						title: 'Complementar Ficha',
					},
					params: {
						placement: 'left',
						enableScrolling: true
					},
					offset: -200
				},
			],

			stepsRating: [
				{
					target: '[data-v-step="srf1"]',  // We're using document.querySelector() under the hood
					content: `<div class="text-left">Haz clic en Llamar Motor de Rating.
					<br>
					<br>
					<div><b>NOTA:</b> toma en cuenta que debes seleccionar los EEFF en la ficha Riesgo Financiero para realizar este proceso.</div></div>

					</div>`,
					header: {
						title: 'Llamar Motor de Rating',
					},
					params: {
						placement: 'left',
						enableScrolling: true
					},
					offset: -200
				},
				{
					target: '[data-v-step="srf2"]',  // We're using document.querySelector() under the hood
					content: `<div class="text-left">Si la consulta al Motor de Rating fue exitosa, se mostrarán campos adicionales.</div>`,
					header: {
						title: 'Rating',
					},
					params: {
						placement: 'left',
						enableScrolling: true
					},
					offset: -200
				},
			],

			stepsPolicies: [
				{
					target: '[data-v-step="sp1"]',  // We're using document.querySelector() under the hood
					content: `<div class="text-left">Recuerda que para desbloquear la ficha de Políticas debes tener todas las fichas del cromo al 100%</div>`,
					header: {
						title: 'Políticas',
					},
					params: {
						placement: 'top',
						enableScrolling: true
					},
					offset: -200
				},
				{
					target: '[data-v-step="sp2"]',  // We're using document.querySelector() under the hood
					content: `<div class="text-left">Selecciona la Moneda en la que agregarás las políticas, debe ser la misma en todos los cromos Grupo/Filial.</div>`,
					header: {
						title: 'Moneda',
					},
					params: {
						placement: 'top',
						enableScrolling: false
					},
				},
				{
					target: '[data-v-step="sp3"]',  // We're using document.querySelector() under the hood
					content: `<div class="text-left">Selecciona el formato en que expresarás las políticas, debe ser la misma en todos los cromos Grupo/Filial.</div>`,
					header: {
						title: 'Formato',
					},
					params: {
						placement: 'top',
						enableScrolling: false
					},
				},
			],

			stepsControls: [
				{
					target: '[data-v-step="sctr1"]',  // We're using document.querySelector() under the hood
					content: `<div class="text-left">Procede con la validación del cliente, una vez que tengas el 100% de avance en cada ficha, y hayas agregado las Políticas para este Cromo.</div>`,
					header: {
						title: 'Validación de cliente',
					},
					params: {
						placement: 'top',
						enableScrolling: true
					},
					offset: -200
				},
			]
		}
	}
}
</script>
<template>
	<div>
		<v-tour name="myTour" :steps="steps">
			<template slot-scope="tour">
				<transition name="fade">
					<v-step
							v-if="tour.currentStep === index"
							v-for="(step, index) of tour.steps"
							:key="index"
							:step="step"
							:previous-step="tour.previousStep"
							:next-step="tour.nextStep"
							:stop="tour.stop"
							:is-first="tour.isFirst"
							:is-last="tour.isLast"
							:labels="tour.labels"
						>
						<template v-if="tour.currentStep === 0">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2">Siguiente</button> -->
							</div>
						</template>
					</v-step>
				</transition>
			</template>
		</v-tour>

		<v-tour name="myTourClients" :steps="stepsClients">
			<template slot-scope="tour">
				<transition name="fade">
					<v-step
						v-if="tour.currentStep === index"
						v-for="(step, index) of tour.steps"
						:key="index"
						:step="step"
						:previous-step="tour.previousStep"
						:next-step="tour.nextStep"
						:stop="tour.stop"
						:is-first="tour.isFirst"
						:is-last="tour.isLast"
						:labels="tour.labels"
					>
						<template v-if="tour.currentStep === 0">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Opción 1</button>
							</div>
						</template>
						<template v-else-if="tour.currentStep === 1">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Opción 2</button>
							</div>
						</template>
						<template v-else-if="tour.currentStep === 2">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button>
							</div>
						</template>
						<template v-else-if="tour.currentStep === 3">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<button @click="tour.stop" class="s-btn s-btn--primary mx-2 my-1">Finalizar</button>
							</div>
						</template>
					</v-step>
				</transition>
			</template>
		</v-tour>

		<v-tour name="myTourClient" :steps="stepsClient">
			<template slot-scope="tour">
				<transition name="fade">
					<v-step
							v-if="tour.currentStep === index"
							v-for="(step, index) of tour.steps"
							:key="index"
							:step="step"
							:previous-step="tour.previousStep"
							:next-step="tour.nextStep"
							:stop="tour.stop"
							:is-first="tour.isFirst"
							:is-last="tour.isLast"
							:labels="tour.labels"
						>
						<template v-if="tour.currentStep == 0">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2">Siguiente</button> -->
							</div>
						</template>
					</v-step>
				</transition>
			</template>
		</v-tour>

		<v-tour name="myTourWizardArce" :steps="stepsWizardArce">
			<template slot-scope="tour">
				<transition name="fade">
					<v-step
							v-if="tour.currentStep === index"
							v-for="(step, index) of tour.steps"
							:key="index"
							:step="step"
							:previous-step="tour.previousStep"
							:next-step="tour.nextStep"
							:stop="tour.stop"
							:is-first="tour.isFirst"
							:is-last="tour.isLast"
							:labels="tour.labels"
						>
						<template v-if="tour.currentStep === 0">
							<div slot="actions">
							</div>
						</template>
						<template v-if="tour.currentStep === 1">
							<div slot="actions">
							</div>
						</template>
						<template v-if="tour.currentStep === 2">
							<div slot="actions">
							</div>
						</template>
						<template v-if="tour.currentStep === 3">
							<div slot="actions">
								<button @click="tour.nextStep" class="s-btn s-btn--primary mx-2">Siguiente</button>
							</div>
						</template>
						<template v-if="tour.currentStep === 4">
							<div slot="actions">
							</div>
						</template>
						<template v-if="tour.currentStep === 5">
							<div slot="actions">
								<button @click="tour.nextStep" class="s-btn s-btn--primary mx-2">Siguiente</button>
							</div>
						</template>
						<template v-if="tour.currentStep === 6">
							<div slot="actions">
							</div>
						</template>
						<template v-if="tour.currentStep === 7">
							<div slot="actions">
							</div>
						</template>
					</v-step>
				</transition>
			</template>
		</v-tour>
		<v-tour name="myTourWizardArcePosponed" :steps="stepsWizardArcePosponed">
			<template slot-scope="tour">
				<transition name="fade">
					<v-step
							v-if="tour.currentStep === index"
							v-for="(step, index) of tour.steps"
							:key="index"
							:step="step"
							:previous-step="tour.previousStep"
							:next-step="tour.nextStep"
							:stop="tour.stop"
							:is-first="tour.isFirst"
							:is-last="tour.isLast"
							:labels="tour.labels"
						>
						<template v-if="tour.currentStep === 0">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2">Siguiente</button> -->
							</div>
						</template>
						<template v-if="tour.currentStep === 1">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<button @click="tour.nextStep" class="s-btn s-btn--primary mx-2">Siguiente</button>
							</div>
						</template>
						<template v-if="tour.currentStep === 2">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2">Siguiente</button> -->
							</div>
						</template>
						<template v-if="tour.currentStep === 2">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2">Siguiente</button> -->
							</div>
						</template>
						<template v-if="tour.currentStep === 3">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2">Siguiente</button> -->
							</div>
						</template>
					</v-step>
				</transition>
			</template>
		</v-tour>
		<v-tour name="myTourClientSearch" :steps="stepsClientSearch">
			<template slot-scope="tour">
				<transition name="fade">
					<v-step
					v-if="tour.currentStep === index"
					v-for="(step, index) of tour.steps"
					:key="index"
					:step="step"
					:previous-step="tour.previousStep"
					:next-step="tour.nextStep"
					:stop="tour.stop"
					:is-first="tour.isFirst"
					:is-last="tour.isLast"
					:labels="tour.labels"
						>
						<template v-if="tour.currentStep === 0">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<button @click="tour.nextStep" class="s-btn s-btn--primary mx-2">Siguiente</button>
							</div>
						</template>
						<template v-if="tour.currentStep === 1">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2">Siguiente</button> -->
							</div>
						</template>
					</v-step>
				</transition>
			</template>
		</v-tour>

		<v-tour name="stepsArceDetails" :steps="stepsArceDetails">
			<template slot-scope="tour">
				<transition name="fade">
					<v-step
						v-if="tour.currentStep === index"
						v-for="(step, index) of tour.steps"
						:key="index"
						:step="step"
						:previous-step="tour.previousStep"
						:next-step="tour.nextStep"
						:stop="tour.stop"
						:is-first="tour.isFirst"
						:is-last="tour.isLast"
						:labels="tour.labels"
					>
						<template v-if="tour.currentStep === 0">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button>

							</div>
						</template>
						<template v-else-if="tour.currentStep === 1">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button>

							</div>
						</template>
						<template v-else-if="tour.currentStep === 2">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->
							</div>
						</template>
						<template v-else-if="tour.currentStep === 3">
							<div slot="actions">
								<button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button>
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.stop" class="s-btn s-btn--primary mx-2 my-1">Finalizar</button> -->
							</div>
						</template>
						<template v-else-if="tour.currentStep === 4">
							<div slot="actions">
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.stop" class="s-btn s-btn--primary mx-2 my-1">Finalizar</button> -->
							</div>
						</template>
						<template v-else-if="tour.currentStep === 5">
							<div slot="actions">
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.stop" class="s-btn s-btn--primary mx-2 my-1">Finalizar</button> -->
							</div>
						</template>
						<template v-else-if="tour.currentStep === 6">
							<div slot="actions">
								<button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button>
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.stop" class="s-btn s-btn--primary mx-2 my-1">Finalizar</button> -->
							</div>
						</template>
						<template v-else-if="tour.currentStep === 7">
							<div slot="actions">
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.stop" class="s-btn s-btn--primary mx-2 my-1">Finalizar</button> -->
							</div>
						</template>
						<template v-else-if="tour.currentStep === 8">
							<div slot="actions">
								<button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button>
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.stop" class="s-btn s-btn--primary mx-2 my-1">Finalizar</button> -->
							</div>
						</template>
						<template v-else-if="tour.currentStep === 9">
							<div slot="actions">
								<button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button>
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.stop" class="s-btn s-btn--primary mx-2 my-1">Finalizar</button> -->
							</div>
						</template>
						<template v-else-if="tour.currentStep === 10">
							<div slot="actions">
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.stop" class="s-btn s-btn--primary mx-2 my-1">Finalizar</button> -->
							</div>
						</template>
						<template v-else-if="tour.currentStep === 11">
							<div slot="actions">
								<button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button>
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.stop" class="s-btn s-btn--primary mx-2 my-1">Finalizar</button> -->
							</div>
						</template>
						<template v-else-if="tour.currentStep === 12">
							<div slot="actions">
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<button @click="tour.stop" class="s-btn s-btn--primary mx-2 my-1">Ocultar</button>
							</div>
						</template>
					
					</v-step>
				</transition>
			</template>
		</v-tour>
		<v-tour name="stepsAnalysisBasicEdit" :steps="stepsAnalysisBasicEdit">
			<template slot-scope="tour">
				<transition name="fade">
					<v-step
						v-if="tour.currentStep === index"
						v-for="(step, index) of tour.steps"
						:key="index"
						:step="step"
						:previous-step="tour.previousStep"
						:next-step="tour.nextStep"
						:stop="tour.stop"
						:is-first="tour.isFirst"
						:is-last="tour.isLast"
						:labels="tour.labels"
					>
						<template v-if="tour.currentStep === 0">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button>

							</div>
						</template>
						<template v-else-if="tour.currentStep === 1">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->

							</div>
						</template>
						<template v-else-if="tour.currentStep === 2">
							<div slot="actions">
								<button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button>

								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->
							</div>
						</template>
						<template v-else-if="tour.currentStep === 3">
							<div slot="actions">
								<button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button>
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.stop" class="s-btn s-btn--primary mx-2 my-1">Finalizar</button> -->
							</div>
						</template>
						<template v-else-if="tour.currentStep === 4">
							<div slot="actions">
								<button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button>

								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.stop" class="s-btn s-btn--primary mx-2 my-1">Finalizar</button> -->
							</div>
						</template>
						<template v-else-if="tour.currentStep === 5">
							<div slot="actions">
								<button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button>

								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.stop" class="s-btn s-btn--primary mx-2 my-1">Finalizar</button> -->
							</div>
						</template>
						<template v-else-if="tour.currentStep === 6">
							<div slot="actions">
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<button @click="tour.stop" class="s-btn s-btn--primary mx-2 my-1">Ocultar</button>
							</div>
						</template>
					
					</v-step>
				</transition>
			</template>
		</v-tour>
		<v-tour name="stepsAnalysisFinancialRisk" :steps="stepsAnalysisFinancialRisk">
			<template slot-scope="tour">
				<transition name="fade">
					<v-step
						v-if="tour.currentStep === index"
						v-for="(step, index) of tour.steps"
						:key="index"
						:step="step"
						:previous-step="tour.previousStep"
						:next-step="tour.nextStep"
						:stop="tour.stop"
						:is-first="tour.isFirst"
						:is-last="tour.isLast"
						:labels="tour.labels"
					>
						<template v-if="tour.currentStep === 0">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->

							</div>
						</template>
						<template v-else-if="tour.currentStep === 1">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->

							</div>
						</template>
						<template v-else-if="tour.currentStep === 2">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button>
							</div>
						</template>
						<template v-else-if="tour.currentStep === 3">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->
							</div>
						</template>
						<template v-else-if="tour.currentStep === 4">
							<div slot="actions">
								<button @click="tour.stop" class="s-btn s-btn--primary mx-2 my-1">Ocultar</button>
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->
							</div>
						</template>
					
					</v-step>
				</transition>
			</template>
		</v-tour>
		<v-tour name="stepsRating" :steps="stepsRating">
			<template slot-scope="tour">
				<transition name="fade">
					<v-step
						v-if="tour.currentStep === index"
						v-for="(step, index) of tour.steps"
						:key="index"
						:step="step"
						:previous-step="tour.previousStep"
						:next-step="tour.nextStep"
						:stop="tour.stop"
						:is-first="tour.isFirst"
						:is-last="tour.isLast"
						:labels="tour.labels"
					>
						<template v-if="tour.currentStep === 0">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->

							</div>
						</template>
						<template v-else-if="tour.currentStep === 1">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->
								<button @click="tour.stop" class="s-btn s-btn--primary mx-2 my-1">Ocultar</button>
							</div>
						</template>
						<template v-else-if="tour.currentStep === 2">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->
							</div>
						</template>
						<template v-else-if="tour.currentStep === 3">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->
							</div>
						</template>
						<template v-else-if="tour.currentStep === 4">
							<div slot="actions">
								<!-- <button @click="tour.stop" class="s-btn s-btn--primary mx-2 my-1">Ocultar</button> -->
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->
							</div>
						</template>
					
					</v-step>
				</transition>
			</template>
		</v-tour>
		<v-tour name="stepsPolicies" :steps="stepsPolicies">
			<template slot-scope="tour">
				<transition name="fade">
					<v-step
						v-if="tour.currentStep === index"
						v-for="(step, index) of tour.steps"
						:key="index"
						:step="step"
						:previous-step="tour.previousStep"
						:next-step="tour.nextStep"
						:stop="tour.stop"
						:is-first="tour.isFirst"
						:is-last="tour.isLast"
						:labels="tour.labels"
					>
						<template v-if="tour.currentStep === 0">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->

							</div>
						</template>
						<template v-else-if="tour.currentStep === 1">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button>
								<!-- <button @click="tour.stop" class="s-btn s-btn--primary mx-2 my-1">Ocultar</button> -->
							</div>
						</template>
						<template v-else-if="tour.currentStep === 2">
							<div slot="actions">
								<button @click="tour.stop" class="s-btn s-btn--primary mx-2 my-1">Ocultar</button>

								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->
							</div>
						</template>
						<template v-else-if="tour.currentStep === 3">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->
							</div>
						</template>
						<template v-else-if="tour.currentStep === 4">
							<div slot="actions">
								<!-- <button @click="tour.stop" class="s-btn s-btn--primary mx-2 my-1">Ocultar</button> -->
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->
							</div>
						</template>
					
					</v-step>
				</transition>
			</template>
		</v-tour>
		<v-tour name="stepsControls" :steps="stepsControls">
			<template slot-scope="tour">
				<transition name="fade">
					<v-step
						v-if="tour.currentStep === index"
						v-for="(step, index) of tour.steps"
						:key="index"
						:step="step"
						:previous-step="tour.previousStep"
						:next-step="tour.nextStep"
						:stop="tour.stop"
						:is-first="tour.isFirst"
						:is-last="tour.isLast"
						:labels="tour.labels"
					>
						<template v-if="tour.currentStep === 0">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->

							</div>
						</template>
						<template v-else-if="tour.currentStep === 1">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button>
								<!-- <button @click="tour.stop" class="s-btn s-btn--primary mx-2 my-1">Ocultar</button> -->
							</div>
						</template>
						<template v-else-if="tour.currentStep === 2">
							<div slot="actions">
								<button @click="tour.stop" class="s-btn s-btn--primary mx-2 my-1">Ocultar</button>

								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->
							</div>
						</template>
						<template v-else-if="tour.currentStep === 3">
							<div slot="actions">
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->
							</div>
						</template>
						<template v-else-if="tour.currentStep === 4">
							<div slot="actions">
								<!-- <button @click="tour.stop" class="s-btn s-btn--primary mx-2 my-1">Ocultar</button> -->
								<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary mx-2">Anterior</button> -->
								<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary mx-2 my-1">Siguiente</button> -->
							</div>
						</template>
					
					</v-step>
				</transition>
			</template>
		</v-tour>


	</div>
</template>
<style lang="scss" scoped>
::v-deep {
	.v-step{
		background-color: #0070D2;
	}
	.v-step__header{
		background-color: #045397;
	}
	.v-step .v-step__arrow{
		border-color: #0070D2;
	}
	.v-step[x-placement^=bottom] .v-step__arrow{
		border-width: 0 .75rem 1.5rem .75rem;
		top: -1.5rem;
	}

	.v-step[x-placement^=right] .v-step__arrow{
		border-width: .75rem  1.5rem .75rem 0 ;
		left: -1.5rem;
	}
	.v-step[x-placement^=left] .v-step__arrow{
		border-width: .75rem 0 .75rem  1.5rem;
		right: -1.5rem;
	}
	.v-step[x-placement^=top] .v-step__arrow{
		border-width: 1.5rem .75rem 0 .75rem;
		bottom: -1.5rem;
	}

	.v-step[x-placement^=bottom] {
		margin-top: 1.5rem;
	}
	.v-step[x-placement^=top] {
		margin-bottom: 1.5rem;
	}
	.v-step[x-placement^=left] {
		margin-right: 1.5rem;
	}
	.v-step[x-placement^=right] {
		margin-left: 1.5rem;
	}
}
</style>